import { Stack } from "@mui/material";
import { downloadSummaryEnabled, hasPermission } from "../../../components/Permissions";
import Permissions from "../../../constants/permissions";
import useAuth from "../../../context/UserContext";
import { DownloadsSummaryHome } from "../../homepage/components/DownloadsSummaryHome";
import { DataUnderManagement } from "../components/DataUnderManagement";

const Homepage = () => {
  const { user } = useAuth();

  const isDownloadSummaryEnabled = downloadSummaryEnabled(user);
  return (
    <>
      <Stack spacing={2}>
        {isDownloadSummaryEnabled || hasPermission(Permissions.ManageGlobalUsers, user) ? (
          <DownloadsSummaryHome csOnly={!isDownloadSummaryEnabled} />
        ) : null}
      </Stack>
      <Stack sx={{ mt: "38px", gap: "32px", padding: "0 0 12px 0" }}>
        <DataUnderManagement />
      </Stack>
    </>
  );
};

export { Homepage };
